import { render, staticRenderFns } from "./ElementWeightPlanTableColumn.vue?vue&type=template&id=20062893&scoped=true"
import script from "./ElementWeightPlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementWeightPlanTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementWeightPlanTableColumn.vue?vue&type=style&index=0&id=20062893&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20062893",
  null
  
)

export default component.exports